import { NonIdealState } from '@gilbarbara/components';

import Background from '~/components/Background';
import Gap from '~/components/Gap';
import StyledLink from '~/components/StyledLink';

function NotFound() {
  return (
    <Background key="404" data-component-name="NotFound">
      <div>
        <NonIdealState />
        <Gap t={50} />

        <div className="center">
          <StyledLink variant="primary" size="lg" to={'/'}>
            Go Home
          </StyledLink>
        </div>
      </div>
    </Background>
  );
}

export default NotFound;
